<button style="float:right;" class="btn btn-primary" type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
  {{ 'texto_60' | translate }}
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 class="card-title">{{ 'texto_58' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100; float: right; margin-top: -2.8rem;" class="btn btn-dark"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <form [formGroup]="validatingForm">
          <div class="row">
            <div class="md-form mb-3 col-md-12">
              <input type="text" class="form-control" formControlName="signupFormModalId" maxlength="50" mdbInput
                mdbValidate>
              <label>ID</label>
              <mdb-error *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>

            <div class="md-form mb-3 col-md-12">
              <input type="text" class="form-control" formControlName="signupFormModalName" maxlength="255" mdbInput
                mdbValidate>
              <label>{{ 'texto_44' | translate }}</label>
              <mdb-error
                *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>

              <mdb-success
                *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>
          </div>

          <div class="row">
            <div class="md-form mb-3 col-md-12">
              <input type="email" class="form-control" formControlName="signupFormModalEmail" mdbInput mdbValidate>
              <label>Email</label>
              <mdb-error
                *ngIf="signupFormModalEmail.invalid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success
                *ngIf="signupFormModalEmail.valid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>
          </div>

          <div class="md-form">
            <label>{{ 'texto_46' | translate }}</label>
            <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 20%;"></mdb-icon>
            <textarea class="md-textarea form-control" rows="5" formControlName="contactFormModalMessage"
              maxlength="4000" mdbInput></textarea>

            <mdb-error
              *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
              {{ 'texto_61' | translate }}
            </mdb-error>
            <mdb-success
              *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
              {{ 'texto_62' | translate }}
            </mdb-success>
          </div>
        </form>

        <div class="text-center mt-3">
          <button (click)="addAbogado()" mdbBtn rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect>
            {{ 'texto_60' | translate }}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>